<!-- Inline edit for Area Functionality property -->
<form [formGroup]="form" class="mat-form-inline">

  <!-- Area Functionality -->
  <mat-form-field>
    <mat-select formControlName="functionality">
      <mat-option *ngFor="let functionality of functionalitiesIds" 
      [value]="functionality" 
      [disabled]="authService.canUpdate('area') === false">
        {{ getDisplayName(functionality) }}
      </mat-option>
    </mat-select>
  </mat-form-field>

</form>
